<template>
  <section :class="sectionClass" class="block block-feature">
    <div v-if="feature" class="container">
      <FeaturedTopicsCard
        v-editable="blok"
        :blok="feature"
        :is-flipped="blok.is_flipped"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import type { BlockFeatureStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: BlockFeatureStoryblok
  customStory?: StoryContentBlok
}>()
const { sectionClass } = useStoryContent(toRefs(props))
const feature = ref()

async function fetch() {
  if (!props.blok.reference) return
  const story = await useStoryblokHelpers().fetchAsyncStory(
    props.blok.reference,
    {
      find_by: 'uuid',
    },
  )
  feature.value = story.value
}

watch(() => props.blok.reference, fetch)
await fetch()
</script>

<style lang="less" scoped>
.block-feature .container {
  padding: 0;
}
</style>
